export type MatchStatus = 'pending' | 'in_progress' | 'completed';
export type BracketType = 'winners' | 'losers' | 'second_losers' | 'grand_final';

export interface Match {
  id: string;
  tournamentId: string;
  round: number;
  matchNumber: number;
  bracketType: BracketType;
  participant1Id?: string;
  participant2Id?: string;
  winnerId?: string;
  status: MatchStatus;
  scoreParticipant1?: number;
  scoreParticipant2?: number;
  nextMatchId?: string;
  loserNextMatchId?: string;
  createdAt: Date;
  updatedAt: Date;
}
